import { ref, watchEffect } from 'vue'

export function asyncComputed(callback, defaultValue = null) {
    const error = ref(null)
    const initialized = ref(false)
    const updating = ref(false)
    const value = ref(defaultValue)

    let abort = null

    const update = async function () {
        abort?.abort()

        abort = new AbortController()

        error.value = null
        updating.value = true

        try {
            value.value = await callback(abort.signal)
        } catch (err) {
            if (err.code !== err.ABORT_ERR) {
                console.error(err)
                console.log(err)
                error.value = err
            }
        } finally {
            abort = null

            updating.value = false

            if (!initialized.value) {
                initialized.value = true
            }
        }
    }

    watchEffect(update)

    return {
        get __v_isRef() {
            return true
        },
        get error() {
            return error.value
        },
        get initialized() {
            return initialized.value
        },
        get updating() {
            return updating.value
        },
        get value() {
            return value.value
        },
        set value(v) {
            value.value = v
        },
        get update() {
            return update
        },
    }
}
